import React, { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { api, resolveAsset } from "../lib/api";

export default function ImageUploader({ value, onChange, label = "Image", aspect = "video" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [drag, setDrag] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const r = await api.post("/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(r.data.url);
    } catch (e) {
      alert("Upload failed: " + (e.response?.data?.detail || e.message));
    } finally {
      setUploading(false);
    }
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDrag(false);
    upload(e.dataTransfer.files?.[0]);
  };

  return (
    <div>
      {label && <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>}
      <div
        onDragOver={(e) => {
          e.preventDefault();
          setDrag(true);
        }}
        onDragLeave={() => setDrag(false)}
        onDrop={onDrop}
        onClick={() => inputRef.current?.click()}
        className={`relative cursor-pointer border-2 border-dashed rounded-md transition-colors ${
          drag ? "border-[#a08862] bg-[#f5ebd6]" : "border-gray-300 bg-gray-50 hover:bg-gray-100"
        } ${aspect === "square" ? "aspect-square" : "aspect-video"} flex items-center justify-center overflow-hidden`}
      >
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => upload(e.target.files?.[0])}
        />
        {uploading ? (
          <Loader2 className="animate-spin text-[#a08862]" />
        ) : value ? (
          <>
            <img src={resolveAsset(value)} alt="" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onChange("");
              }}
              className="absolute top-2 right-2 bg-black/60 text-white rounded-full p-1 hover:bg-black/80"
            >
              <X size={14} />
            </button>
          </>
        ) : (
          <div className="text-center text-gray-500 text-sm p-4">
            <Upload className="mx-auto mb-2" />
            Drag &amp; drop or click to upload
          </div>
        )}
      </div>
      <div className="mt-2">
        <input
          type="text"
          placeholder="Or paste image URL"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="w-full text-xs border rounded px-2 py-1"
        />
      </div>
    </div>
  );
}
